export const UserType = {


	list: function(){
		if (!jQuery.fn.DataTable.isDataTable('table.role-management')) {
	    var callsTable = jQuery('table.role-management').dataTable(
	    {
	      aaData: JSON.parse(jQuery('#role-data').html()),
	      info: false,
	      lengthChange: false,
		  language: {
			searchPlaceholder: I18n.t('search')
		  },
	    //   searching: false,
				autoWidth: false,
				retrieve: true,
				initComplete: function () {
					DataTablesHelper.setAutoComplete(jQuery('table.role-management'));
				},
	      aoColumnDefs: [
	        {
	          mRender: function(data, type, rowData) {
	            // return data.edit + data.ip_restrictions + data.delete
	            return Object.keys(data).map(function(i){return data[i]}).join(' ');
	          },
	         orderable: false,
	        searchable: false,
	        // width: '120px',
	        aTargets: [-1]
	      }
	    ],
		drawCallback: function () {
			DataTablesHelper.addColumnFilters(this);
		},
        footerCallback: function () {
          DataTablesHelper.togglePagination(this);
        }
	    });
		}
		jQuery('.role-management.dataTable').on('click', 'a.delete-role' , function(e){
			if (confirm(jQuery(this).attr('data-confirm'))) {
				jQuery.post(jQuery(this).attr('href'), function(d){
					if (d.status){
						jQuery('#modal-dialog', top.document).modal('hide');
						top.Turbo.visit(top.location.href);
					}
				});

				e.preventDefault();
				return false;
			}

			e.preventDefault();
			return false;
		});


		jQuery('body').delegate('button.new-ip-restriction', 'click', function() {
			var newRow = jQuery('#ip-restriction-template').html().replace(/__randId__/g, SmartME.generateUniqueId());
			jQuery('#ip-restriction-action-row').before(newRow);
		});

		jQuery('body').delegate('button.delete-ip-restriction', 'click', function() {
			jQuery(this).closest('.ip-restriction-row').remove();
		});

	},


	new: function(){
		jQuery('.permission-edit-warning').hide();
		jQuery('.form-check-input').on('change', this._toggleWarningText);
	},


	edit: function(){
		ActionJS.UserType.new();
	},


	_toggleWarningText: function(){
		var warningText = jQuery(this).data('warning'),
		id = jQuery(this).attr('value'),
		container = jQuery('.permission-edit-warning ul'),
		exists = container.find('#' + id);

		if (warningText.length === 0) return;

		if (exists.length > 0) {
			exists.remove();
		} else {
			container.append('<li id="' + id + '"><strong>' + jQuery(this).closest('label').text() + ':</strong> ' + warningText + '</li>');
		}

		if (container.find('li').length === 0){
			jQuery('.permission-edit-warning').hide();
		} else {
			jQuery('.permission-edit-warning').show();	
		}
  },
  
  _initEditRestrictions: function(){
		jQuery('.smartme-toggle').smartmeToggle();
		jQuery('[data-tooltip="true"]').tooltip();
  }


}
